
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4438c82e819f1918$exports = {};

$parcel$export($4438c82e819f1918$exports, "spectrum--light", function () { return $4438c82e819f1918$export$efb37c2f79da8163; }, function (v) { return $4438c82e819f1918$export$efb37c2f79da8163 = v; });
var $4438c82e819f1918$export$efb37c2f79da8163;
$4438c82e819f1918$export$efb37c2f79da8163 = `YqfL3a_spectrum--light`;


export {$4438c82e819f1918$exports as default};
//# sourceMappingURL=vars_spectrum-light_css.mjs.map
